<template>
  <div>
    <a
      @click.prevent="toggleIsShowFilter()"
      class="filter-toggle text-uppercase font-bai font-bold text-center relative-section"
    >
      {{ $t("app.Filter") }}
      <i class="fa fa-angle-down"></i>
    </a>
    <slide-up-down tag="div" :active="isShowFilter" :duration="300">
      <div class="filter-sidebar">
        <form action id="filterForm" v-click-outside="clickOutSite">
          <h3 class="font-bai text-uppercase">{{ $t("app.Filtrer par") }} :</h3>
          <div class="form-group">
            <div
              class="select-custom"
              :class="{
                                active: isOpenDopdown === 'campings'
                            }"
            >
              <a href class="current" @click.prevent="setIsOpenDropdown('campings')">
                <span v-if="camping && camping.title" v-html="camping.title.rendered"></span>
              </a>
              <slide-up-down :active="isOpenDopdown === 'campings'" tag="ul" :duration="100">
                <li v-for="(item, index) in campingClubs" :key="index">
                  <a
                    @click.prevent="
                                            onChangeFilter('camping', item)
                                        "
                    v-html="item.title.rendered"
                  ></a>
                </li>
              </slide-up-down>
            </div>
          </div>
          <div class="form-group">
            <div
              class="select-custom"
              :class="{
                                active: isOpenDopdown === 'chalets'
                            }"
            >
              <a href class="current" @click.prevent="setIsOpenDropdown('chalets')">
                {{
                type && type.title
                ? type.title.rendered
                : $t("app.Please select")
                }}
              </a>
              <slide-up-down
                :active="isOpenDopdown === 'chalets'"
                tag="ul"
                :duration="100"
                v-if="typesOptions.length > 0"
              >
                <li v-for="(item, index) in typesOptions" :key="index">
                  <a
                    @click.prevent="
                                            onChangeFilter('type', item)
                                        "
                  >{{ item.title.rendered }}</a>
                </li>
              </slide-up-down>
            </div>
          </div>
          <div class="form-group">
            <div
              class="select-custom"
              :class="{
                                active: isOpenDopdown === 'categorie'
                            }"
            >
              <a href class="current" @click.prevent="setIsOpenDropdown('categorie')">
                {{
                categorie.title
                ? categorie.title.rendered
                : $t("app.Toutes catégories")
                }}
              </a>
              <slide-up-down :active="isOpenDopdown === 'categorie'" tag="ul" :duration="100">
                <li v-for="(item, index) in categoriesOptions" :key="index">
                  <a
                    @click.prevent="
                                            onChangeFilter('categorie', item)
                                        "
                  >{{ item.title.rendered }}</a>
                </li>
              </slide-up-down>
            </div>
          </div>
          <div class="form-group">
            <div class="select-custom date-group">
              <a href class="current" @click.prevent>
                {{ $t("app.Du") }}
                <date-picker
                  v-model="dateFrom"
                  format="DD/MM/YYYY"
                  type="date"
                  class="datepicker"
                  placeholder="dd/mm/Y"
                  :disabled-date="disabledDateFrom"
                  @open="onOpenDatePicker('dateFrom')"
                  @change="onChangeFromDatePicker"
                ></date-picker>
              </a>
            </div>
          </div>
          <div class="form-group">
            <div class="select-custom date-group">
              <a href class="current" @click.prevent>
                {{ $t("app.au") }}
                <date-picker
                  v-model="dateTo"
                  format="DD/MM/YYYY"
                  type="date"
                  class="datepicker"
                  placeholder="dd/mm/Y"
                  :disabled-date="notBeforeDate"
                  @open="onOpenDatePicker('dateTo')"
                  @change="onChangeToDatePicker"
                ></date-picker>
              </a>
            </div>
          </div>
          <div class="form-group">
            <div
              class="select-custom field-people"
              :class="{
                                active: isOpenDopdown === 'adultes'
                            }"
            >
              <a href class="current" @click.prevent="setIsOpenDropdown('adultes')">
                {{
                adult + child + child1 > 0
                ? adult + child + child1
                : $t("app.adultes")
                }}
              </a>
              <slide-up-down :active="isOpenDopdown === 'adultes'" tag="ul" :duration="100">
                <li class="quantity-item" v-for="(item, index) in adultsConfig" :key="index">
                  <b>{{ item.name }}</b>
                  <div class="quantity-group quantity-adulte">
                    <a
                      href
                      class="minus"
                      @click.prevent="
                                                item.quantity > 0
                                                    ? item.quantity--
                                                    : 0
                                            "
                      v-bind:class="{
                                                isDisabled: item.quantity <= 0
                                            }"
                    >-</a>
                    <input type="number" min="0" disabled v-model="item.quantity" />
                    <a href class="plus" @click.prevent="item.quantity++">+</a>
                  </div>
                </li>
                <li>
                  <a class="btn apply" @click.prevent="onApplyAdults()">{{ $t("app.Ajouter") }}</a>
                </li>
              </slide-up-down>
            </div>
          </div>
          <div class="services-more" v-if="services.length > 0">
            <h3 class="font-bai text-uppercase">{{ $t("app.Services") }} :</h3>
            <ul class="services-list">
              <li v-for="(item, index) in servicesList" :key="index">
                <label class="checkbox-custom font-bai active checkbox-show">
                  <div class="des">
                    <h4>{{ item.name }}</h4>
                    <p>
                      <i v-html="item.description"></i>
                    </p>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </slide-up-down>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import ClickOutside from "vue-click-outside";
import { mapState, mapActions, mapMutations } from "vuex";
import {
  get,
  find,
  forEach,
  chain,
  map,
  flatten,
  uniqBy,
  filter,
  includes,
} from "lodash";
import { adults } from "@/helper/config";
// import moment from "moment";
import { formatBookDate } from "@/helper/calculateDays";
const today = new Date();

export default {
  name: "FilterSidebar",
  components: { DatePicker },
  data() {
    const adultsConfig = adults.filter((item) => item.key !== "animal");

    return {
      isOpenDopdown: null,
      dateFrom: null,
      dateTo: null,
      camping: {},
      type: {},
      categorie: {},
      adult: null,
      child: null,
      child1: null,
      animal: null,
      adultsConfig: adultsConfig,
      servicesList: [],
      typesOptions: [],
      categoriesOptions: [],
      isShowFilter: false,
    };
  },
  created() {
    if (this.$isMobile()) {
      this.isShowFilter = false;
    } else {
      this.isShowFilter = true;
    }
  },
  mounted() {
    const camping = find(
      this.campingClubs,
      (item) => item.id === this.filter.camping
    );
    this.camping = camping;
    const type = find(this.types, (item) => item.id === this.filter.type);
    this.type = type || {};
    this.getTypesByCamping(camping);
    this.getCategoriesByCampingAndType();
    const categorie = find(
      this.categoriesOptions,
      (item) => item.id === this.filter.categorie
    );
    const servicesList = flatten(
      chain(uniqBy(this.services, "camping")).map("value").value()
    );
    this.servicesList = servicesList;
    this.categorie = categorie || {};
    this.adult = this.filter.adult;
    this.child = this.filter.child;
    this.child1 = this.filter.child1;
    this.animal = this.filter.animal;
    this.dateFrom = new Date(this.filter.dateFrom);
    this.dateTo = this.filter.dateTo ? new Date(this.filter.dateTo) : null;
    if (get(type, "title.rendered", "") === "Emplacement nu") {
      this.adultsConfig = adults.map((item) => ({
        ...item,
        quantity: get(this.filter, item.key) || 0,
      }));
    } else {
      this.adultsConfig = this.adultsConfig.map((item) => {
        const qty = get(this.filter, item.key);
        return {
          ...item,
          quantity: qty,
        };
      });
    }
  },
  computed: {
    ...mapState({
      campingClubs: (state) => get(state, "campingClubs.list", []),
      categories: (state) => get(state, "categories.list", []),
      types: (state) => get(state, "types.list", []),
      filter: (state) => get(state, "hotels.filter", {}),
      services: (state) => get(state, "hotels.references.services", []),
    }),
  },
  methods: {
    ...mapMutations("hotels", ["setFilter"]),
    ...mapActions("hotels", ["getAvailability", "getReferences"]),
    disabledDateFrom(date) {
      if (!this.dateTo) {
        return date <= today;
      }
      return date <= today || date >= this.dateTo;
    },
    notBeforeDate(date) {
      return date <= this.dateFrom;
    },
    setIsOpenDropdown(key) {
      this.isOpenDopdown = this.isOpenDopdown !== key ? key : null;
    },
    clickOutSite() {
      this.isOpenDopdown = null;
    },
    onOpenDatePicker(type) {
      this.isOpenDopdown = null;
      if (type === "dateFrom") {
        this.onChangeFilter("dateTo", null);
      }
    },
    onChangeFromDatePicker(date) {
      this.onChangeFilter("dateFrom", date);
    },
    onChangeToDatePicker(date) {
      this.onChangeFilter("dateTo", date);
    },
    onChangeFilter(key, data) {
      this[key] = data;
      let dataReferences = this.filter;
      if (key === "camping" || key === "type" || key === "categorie") {
        if (key === "camping") {
          this.getTypesByCamping(data);
          this.categorie = {}; // reset category
        }
        if (key === "type") {
          if (data.title.rendered === "Emplacement nu") {
            this.adultsConfig = adults.map((item) => ({
              ...item,
              quantity: get(this.filter, item.key) || 0,
            }));
          } else {
            const adultsConfig = adults.filter((item) => item.key !== "animal");
            this.adultsConfig = adultsConfig.map((item) => ({
              ...item,
              quantity: get(this.filter, item.key) || 0,
            }));
            this.animal = 0; // reset animal
            delete dataReferences["animal"];
          }
          this.categorie = {}; // reset category
        }
        this.type =
          find(
            this.typesOptions,
            (typeItem) => typeItem.id === get(this, "type.id")
          ) || {};
        this.getCategoriesByCampingAndType();
        // this.categorie =
        //   find(
        //     this.categoriesOptions,
        //     item => item.id === get(this, "categorie.id")
        //   ) || {};
        dataReferences = {
          ...dataReferences,
          camping: get(this, "camping.id"),
          type: get(this, "type.id"),
          categorie: get(this, "categorie.id"),
          [key]: data.id,
        };
      } else {
        dataReferences = {
          ...dataReferences,
          [key]: data,
        };
        if (key === "dateFrom") {
          dataReferences.dateTo = null;
        }
      }
      this.setFilter(dataReferences);
      this.onGetRefences(dataReferences);
      this.isOpenDopdown = null;
    },
    onApplyAdults() {
      forEach(this.adultsConfig, (item) => {
        this[item.key] = item.quantity;
      });
      this.isOpenDopdown = null;
      let dataReferences = this.filter;
      dataReferences = {
        ...dataReferences,
        adult: this.adult,
        child: this.child || 0,
        child1: this.child1 || 0,
      };
      if (this.animal !== 0) {
        dataReferences.animal = this.animal;
      }
      this.onGetRefences(dataReferences);
    },
    onGetRefences(dataReferences) {
      if (
        !dataReferences.dateFrom ||
        !dataReferences.dateTo ||
        dataReferences.adult <= 0
      ) {
        // this.$bvToast.toast("Please select date from, date to", {
        //     title: `Error`,
        //     variant: "danger",
        //     solid: true
        // });
        return;
      }
      if (this.adult + this.child + this.child1 > 6) {
        this.$bvToast.toast(
          this.$i18n.t(
            "app.Les hébergements ne peuvent pas accueillir plus de 6 personnes"
          ),
          {
            title: this.$i18n.t("app.Error"),
            variant: "danger",
            solid: true,
          }
        );
        return;
      }
      dataReferences = {
        ...dataReferences,
        dateFrom: formatBookDate(dataReferences.dateFrom),
        dateTo: formatBookDate(dataReferences.dateTo),
      };
      this.getReferences(dataReferences).then((res) => {
        const { references } = res;
        if (references) {
          const data = {
            StartUtc: formatBookDate(dataReferences.dateFrom),
            EndUtc: formatBookDate(dataReferences.dateTo),
            AdultCount: dataReferences.adult,
            ChildCount:
              Number(dataReferences.child) + Number(dataReferences.child1),
            CategoryIds: map(references, (item) => item.id),
          };
          this.getAvailability(data);
        }
      });
    },
    getTypesByCamping(camping) {
      const types = filter(this.types, (item) => {
        if (Array.isArray(get(item, "acf.types_camping"))) {
          return includes(get(item, "acf.types_camping", []), get(camping, 'id'));
        }
        return get(item, "acf.types_camping") === get(camping, 'id');
      });
      this.typesOptions = types;
    },
    getCategoriesByCampingAndType() {
      if (!this.type || !this.camping) this.categoriesOptions = [];
      const categories = filter(this.categories, (item) => {
        if (
          Array.isArray(get(item, "acf.cacamping_club")) &&
          Array.isArray(get(item, "acf.cate_types"))
        ) {
          return (
            includes(
              get(item, "acf.cacamping_club", []),
              get(this, "camping.id")
            ) && includes(get(item, "acf.cate_types", []), get(this, "type.id"))
          );
        }
      });
      this.categoriesOptions = [
        {
          id: "",
          title: {
            rendered: this.$i18n.t("app.Toutes catégories"),
          },
        },
        ...categories,
      ];
    },
    toggleIsShowFilter() {
      this.isShowFilter = !this.isShowFilter;
    },
  },
  watch: {
    filter: function (filter) {
      const camping = find(
        this.campingClubs,
        (item) => item.id === filter.camping
      );
      this.camping = camping;
      const type = find(this.types, (item) => item.id === filter.type);
      this.type = type || {};
      this.getTypesByCamping(camping);
      this.getCategoriesByCampingAndType();
      const categorie = find(
        this.categoriesOptions,
        (item) => item.id === filter.categorie
      );
      const servicesList = flatten(
        chain(uniqBy(this.services, "camping")).map("value").value()
      );
      this.servicesList = servicesList;

      this.categorie = categorie || {};
      this.adult = filter.adult;
      this.child = filter.child;
      this.child1 = filter.child1;
      this.animal = filter.animal;
      this.dateFrom = new Date(filter.dateFrom);
      this.dateTo = filter.dateTo ? new Date(filter.dateTo) : null;
      if (get(type, "title.rendered", "") === "Emplacement nu") {
        this.adultsConfig = adults.map((item) => ({
          ...item,
          quantity: get(filter, item.key) || 0,
        }));
      } else {
        this.adultsConfig = this.adultsConfig.map((item) => {
          const qty = get(filter, item.key);
          return {
            ...item,
            quantity: qty,
          };
        });
      }
    },
    services: function (services) {
      const servicesList = flatten(
        chain(uniqBy(services, "camping")).map("value").value()
      );
      this.servicesList = servicesList;
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
